/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { FC, useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet'

import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { email } from '../../../utils/validate'
import { createResetRequest } from '../../../states/containers/auth/resetPasswordSlice'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const LoginResetPassword: FC = () => {
  const dispatch = useDispatch()
  const { t, i18n } = useTranslation()
  const [initLang, setInitLang] = useState('ja')

  const [emailErrors, setEmailErrors] = useState<string | undefined>()
  const [isEmailLoading, setIsEmailLoading] = useState<boolean>(false)
  const [isEmailSuccess, setIsEmailSuccess] = useState<boolean>(false)
  const emailRef = useRef<HTMLInputElement>(null)

  const validateEmail = (value: string) => {
    if (!value) {
      setEmailErrors(undefined)
      return false
    }
    const errors = email(value)
    if (errors) {
      setEmailErrors(errors)
      return false
    }
    setEmailErrors(undefined)
    return true
  }

  const handleEmailSubmit = () => {
    if (!emailRef.current?.value) return
    if (!validateEmail(emailRef.current?.value)) return
    setIsEmailLoading(true)
    dispatch(createResetRequest(
      { email: emailRef.current?.value },
      () => {
        setIsEmailSuccess(true)
      },
    ))
  }

  useEffect(() => {
    let browserLangValue = (navigator.languages && navigator.languages[0]) || navigator.language
    if (browserLangValue.match(/en/)) {
      browserLangValue = 'en'
    } else {
      browserLangValue = 'ja'
    }
    setInitLang(browserLangValue)
  }, [])

  useEffect(() => {
    i18n.changeLanguage(initLang)
  }, [initLang, i18n])

  return (
    <>
      <Helmet>
        <title>Qasee - パスワードリセット</title>
      </Helmet>

      <div className="single_wrapper">
        <div className="login-logo">
          <img
            className="login-logo"
            src="/static/images/logo-login.png"
            alt="Logo login"
          />
        </div>
        <div className="sign_in_title">
          {t('login.reset_request.title')}
        </div>
        {
          isEmailSuccess && (
            <div className="success">
              <FontAwesomeIcon icon={['fas', 'check-circle']} size="2x" className="icon" />
              <div className="success_text">
                {t('login.reset_request.success')}
              </div>
            </div>
          )
        }
        <div className="login-box-body">
          <div className="password_reset">
            <div className="input-area">
              <p>
                {t('login.mail')}
              </p>
              <input
                type="text"
                placeholder="Email"
                onChange={(e) => validateEmail(e.target.value)}
                className={emailErrors && "error"}
                ref={emailRef}
                disabled={isEmailLoading || isEmailSuccess}
              />
              {
                emailErrors && (
                  <div className="password_error">{t(`${emailErrors}`)}</div>
                )
              }
            </div>
            <div className="button-area">
              {
                isEmailSuccess ? (
                  <button type="button" className="btn btn-primary" disabled>
                    {t('login.reset_request.button.done')}
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => handleEmailSubmit()}
                  >
                    {
                      isEmailLoading ? (
                        <div className="loading" />
                      ) : (
                        t('login.reset_request.button.text')
                      )
                    }
                  </button>
                )
              }
            </div>
            <div className="supplement">
              <a href="/">{t('login.reset_request.back_login')}</a>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default LoginResetPassword
